var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionDrone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 53,
    viewBox: "0 0 42 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35B7F3",
    opacity: 0.5,
    d: "M21 10.5a21 21 0 1 1 0 42 21 21 0 0 1 0-42z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31.5,
    r: 16,
    fill: "#35B7F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.6 33.16c.33-.06.6.21.6.54 0 .33-.27.59-.59.69a2.1 2.1 0 0 0-1.41 1.9 2.1 2.1 0 0 0 4.04.59c.1-.32.36-.59.7-.59.33 0 .6.27.54.6a3.3 3.3 0 0 1-3.14 2.61 3.3 3.3 0 0 1-3.2-3.2 3.3 3.3 0 0 1 2.46-3.14zm10.8 0a3.3 3.3 0 0 1 2.46 3.14 3.3 3.3 0 0 1-3.2 3.2 3.3 3.3 0 0 1-3.15-2.6c-.06-.34.21-.61.54-.61.33 0 .6.27.7.6a2.1 2.1 0 0 0 4.04-.6 2.1 2.1 0 0 0-1.42-1.9c-.32-.1-.6-.36-.6-.7 0-.33.28-.6.63-.54zM25.16 26.23c.24-.24.62-.24.86 0 .24.24.24.63 0 .87l-2.47 2.48A3.17 3.17 0 0 1 24.2 31.5a3.17 3.17 0 0 1-.52 1.74l2.32 2.32c.24.24.24.63 0 .87a.6.6 0 0 1-.86 0l-2.3-2.3c-.52.36-1.17.57-1.96.57a3.17 3.17 0 0 1-1.95-.57l-2.38 2.38a.6.6 0 0 1-.86 0 .6.6 0 0 1 0-.86l2.43-2.43A3.17 3.17 0 0 1 17.8 31.5c0-.68.22-1.3.59-1.85l-2.59-2.59a.6.6 0 0 1 0-.86.6.6 0 0 1 .86 0l2.59 2.58c.52-.35 1.17-.57 1.95-.57.6 0 1.18.16 1.67.45l2.39-2.39zM16.2 23.5c1.56 0 2.86 1.12 3.15 2.6.06.33-.21.6-.54.6-.33 0-.6-.27-.7-.6a2.1 2.1 0 0 0-4.04.6c0 1 .67 1.86 1.59 2.14.33.1.6.36.6.68s-.27.6-.6.54A3.3 3.3 0 0 1 13 26.7c0-1.76 1.43-3.2 3.2-3.2zm9.6 0c1.77 0 3.2 1.43 3.2 3.2 0 1.76-1.22 3.03-2.7 3.3-.33.06-.6-.21-.6-.54 0-.32.27-.59.6-.69a2.1 2.1 0 0 0 1.42-1.9c0-1.05-.85-1.9-1.94-1.9-.92 0-1.67.59-1.95 1.49-.1.33-.36.59-.68.59-.33 0-.6-.27-.54-.6.29-1.48 1.59-2.6 3.15-2.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.92 8.67A27.7 27.7 0 0 0 21 7.5c-2.43 0-4.76.41-6.93 1.17L21 0l6.92 8.67z",
    fill: "#35B7F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionDrone);
export default __webpack_public_path__ + "static/media/mission-drone.79e5186841fea6ac151c5507e42c3912.svg";
export { ForwardRef as ReactComponent };